export * from '@client-parents/services/client-parent-details-mapper.service';

import { ClientParentDetailsEffects } from '@client-parents/effects/client-parent-details.effects';
import { ClientParentDetailsService } from '@client-parents/services/client-parent-details.service';
import { ClientParentDetailsMapperService } from '@client-parents/services/client-parent-details-mapper.service';


export const clientParentServices = [
  ClientParentDetailsService,
  ClientParentDetailsMapperService
];

export const clientParentEffects = [
  ClientParentDetailsEffects
];
